import { Injectable, isDevMode } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CustomizationActions, CustomizationApiActions } from './customization.actions';
import { StorageKey, StorageService } from '../../services/shared/storage.service';
import { CustomizationService } from '../../services/customization/customization.service';
import { Customization } from './model/customization.model';

@Injectable()
export class CustomizationEffects {
    constructor(
        private actions$: Actions,
        private storageService: StorageService,
        private customizationService: CustomizationService
    ) {}

    loadCustomization$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CustomizationApiActions.loadCustomization),
            switchMap(() => {
                const tenant = isDevMode() ? 'demo' : location.host.split('.').shift()!;
                return this.customizationService.loadCustomization(tenant).pipe(
                    tap((customization) => this.storageService.set<Customization>(StorageKey.CUSTOMIZATION, customization)),
                    map((customization) => CustomizationActions.loadCustomizationSuccess({ customization })),
                    catchError((error) => of(CustomizationActions.loadCustomizationFailure({ error })))
                );
            })
        );
    });
}
